import { useChainStore } from "./store";
export const getChain = (chainId, chains = useChainStore.getState().chains) => {
    const chain = chains.find((chain) => chain.chainId === chainId);
    if (!chain) {
        throw new Error(`Missing chain ${chainId} from options.chains`);
    }
    return chain;
};
